import { colors } from "@theme/colors"

const BulletListIcon = ({ color = colors.pureWhite, height = 20, width = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4.5" y="5.5" width="2" height="2" rx="1" fill={color} />
      <rect x="8.5" y="6" width="7" height="1" rx="0.5" fill={color} />
      <rect x="4.5" y="9" width="2" height="2" rx="1" fill={color} />
      <rect x="8.5" y="9.5" width="7" height="1" rx="0.5" fill={color} />
      <rect x="4.5" y="12.5" width="2" height="2" rx="1" fill={color} />
      <rect x="8.5" y="13" width="7" height="1" rx="0.5" fill={color} />
    </svg>
  )
}

export default BulletListIcon
